"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
require("./styles/placeholder-tab.scss");
/**
 * PlaceholderTab - Generic placeholder component for tabs under development
 */
var PlaceholderTab = function (_a) {
    var title = _a.title, description = _a.description, className = _a.className;
    return (react_1.default.createElement("div", { className: "ws-placeholder-tab " + (className || '') },
        react_1.default.createElement("div", { className: "ws-placeholder-content" },
            react_1.default.createElement("h3", null, title),
            react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.info },
                "This section is currently under development.",
                ' ',
                description || 'Configuration options will be available in a future release.'),
            react_1.default.createElement("div", { className: "ws-placeholder-details" },
                react_1.default.createElement("p", null,
                    "This area will allow you to configure settings related to",
                    ' ',
                    react_1.default.createElement("strong", null, title.toLowerCase()),
                    ".")))));
};
exports.default = PlaceholderTab;
